<template>
  <create-dialog
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
    width="68%"
  >
    <template slot="form">
      <div class="row">
        <div class="col-12 col-sm-5 col-md-7 col-xl-5">
          <div class="row">
            <div class="col-6 col-sm-12 col-md-6">
              <fg-input
                type="text"
                :label="`${$t('common_words.code')}: *`"
                v-model="model.code"
                v-validate="modelValidations.code"
                name="common_words.code"
                :error="getError('common_words.code', true)"
                :disabled="disabledField"
                @click="handleClickOnCode('samples.ground_types')"
              >
              </fg-input>
            </div>
            <div class="col-6 col-sm-12 col-md-6">
              <fg-input
                type="number"
                :label="`${$t('common_words.order_request')}: *`"
                v-model="model.order"
                v-validate="modelValidations.order"
                name="common_words.order_request"
                :error="getError('common_words.order_request', true)"
              >
              </fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <fg-input
                type="text"
                :label="`${$t('common_words.name')}: *`"
                v-model="model.name"
                v-validate="modelValidations.name"
                name="common_words.name"
                :error="getError('common_words.name', true)"
              >
              </fg-input>
            </div>
          </div>
          <div class="row mb-2">
            <select-component
              :dataOptions="getModulesList"
              :initialSelection="model.module_id"
              @onChange="handleChangeSelect"
              :labelSelect="`${$t('common_words.modules')}: *`"
              modelName="module_id"
              requireClass="required-modules"
              rowClass="col-12"
            />
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group has-label">
                <label>{{ $t('common_words.description') }}:</label>
                <br />
                <el-input
                  maxlength="300"
                  show-word-limit
                  class="shadow-sm"
                  type="textarea"
                  :rows="5"
                  placeholder="..."
                  v-model="model.description"
                ></el-input>
                <br />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-7 col-md-4 col-xl-7">
          <div class="row">
            <div class="col-12 col-xl-6 mb-3">
              <label>{{ $t('common_words.color') }}:</label>
              <sketch-picker
                :value="colors"
                @input="updateValue"
                v-if="renderComponent"
              ></sketch-picker>
            </div>
            <div class="col-12 col-xl-6">
              <div class="form-group has-label">
                <label>{{ $t('common_words.text_color') }}:</label>
                <sketch-picker
                  :value="colorst"
                  @input="updateValueT"
                  v-if="renderComponent"
                ></sketch-picker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import configTable from './status-table';
import InfoTable from 'src/components/Tables/InfoTable.vue';
import MixinColors from 'src/util/mixinColor';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinTranslate from 'src/util/mixinTranslate';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import ModuleClass from 'src/class/ModuleClass';
import SelectClass from 'src/class/SelectClass';

export default {
  name: 'edit-create',
  mixins: [
    MixinColors,
    MixinDialog,
    MixinForm,
    MixinPermissions,
    MixinTranslate,
    MixinValidations,
  ],
  components: {
    [InfoTable.name]: InfoTable,
  },
  data() {
    return {
      disabledField: false,
      model: {
        code: null,
        name: null,
        description: null,
        color: null,
        color_text: null,
        order: null,
        module_id: [],
      },
      modules: [],
      modelValidations: {
        code: { required: true, max: 11 },
        name: { required: true, max: 255 },
        order: { required: true, min_value: 1 },
      },
      selectClass: new SelectClass(this),
      moduleClass: new ModuleClass(this),
    };
  },
  computed: {
    getModulesList() {
      return this.moduleClass.formatLabelModule(this.modules);
    },
  },
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    syncDialog(newValue) {
      if (newValue.create) {
        this.openModal('create', newValue.disabledField);
        this.setOrder();
        this.model = { ...this.model, color: '#194d33', color_text: '#000000' };
      } else this.closeModal('create', newValue.disabledField);
    },
  },
  methods: {
    handleChangeSelect(data) {
      this.selectClass.handleChangeSelected(data);
    },
    updateDisabledField(value) {
      this.disabledField = value;
    },
    updateValueT(value) {
      this.model.color_text = value.hex;
    },
    setOrder() {
      const tableData = Object(JSON.parse(sessionStorage.getItem('tableCode')));
      const order = tableData
        .map((data) => data.order)
        .reduce((prev, current) => prev + current, 0);
      this.model.order = order + 1;
    },
    /**
     * Método para validar un formulario de edición o guardado
     */
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.module_id)) {
            this.validationInputsRequired('modules');
            return false;
          } else {
            this.$emit('addEdit', this.model);
            return true;
          }
        }
      });
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const { code, color, description, id, modules, name, order } = editForm;
      this.model = {
        code,
        description,
        id,
        module_id: modules.map((module) => module.id),
        name,
        order,
        color: color.color,
        color_text: color.color_text,
        isEdit: true,
      };

      this.colors = this.model.color;
      this.colorst = this.model.color_text;

      sessionStorage.removeItem('editForm');
    }
  },
  created() {
    if (this.isIndex()) {
      Promise.all([Axios.getMasters('modules/indexfield')])
        .then((response) => {
          const [responseModules] = response;
          this.modules = this.concatAll(responseModules.data.data);
        })
        .catch((error) => {
          this.showMessageErrors(error);
        });
    } else {
      this.showMessageAccess();
    }
  },
};
</script>
